/**
 * @desc 列表
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<ObjectMap>;
export function request(
  params: API.rms.expenseReimbursement.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
